﻿import * as FilePond from 'filepond';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
import FilePondPluginImageValidateSize from 'filepond-plugin-image-validate-size';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginImageResize from 'filepond-plugin-image-resize';

const defaultOptions = {
  labelIdle: 'Trascina e rilascia i tuoi file oppure <span class="filepond--label-action">Carica<span>',
  labelInvalidField: "Il campo contiene dei file non validi",
  labelFileWaitingForSize: "Aspettando le dimensioni",
  labelFileSizeNotAvailable: "Dimensioni non disponibili",
  labelFileLoading: "Caricamento",
  labelFileLoadError: "Errore durante il caricamento",
  labelFileProcessing: "Caricamento",
  labelFileProcessingComplete: "Caricamento completato",
  labelFileProcessingAborted: "Caricamento cancellato",
  labelFileProcessingError: "Errore durante il caricamento",
  labelFileProcessingRevertError: "Errore durante il ripristino",
  labelFileRemoveError: "Errore durante l'eliminazione",
  labelTapToCancel: "tocca per cancellare",
  labelTapToRetry: "tocca per riprovare",
  labelTapToUndo: "tocca per ripristinare",
  labelButtonRemoveItem: "Elimina",
  labelButtonAbortItemLoad: "Cancella",
  labelButtonRetryItemLoad: "Ritenta",
  labelButtonAbortItemProcessing: "Camcella",
  labelButtonUndoItemProcessing: "Indietro",
  labelButtonRetryItemProcessing: "Ritenta",
  labelButtonProcessItem: "Carica",
  labelMaxFileSizeExceeded: "Il peso del file è eccessivo",
  labelMaxFileSize: "Il peso massimo del file è {filesize}",
  labelMaxTotalFileSizeExceeded: "Dimensione totale massima superata",
  labelMaxTotalFileSize: "La dimensione massima totale del file è {filesize}",
  labelFileTypeNotAllowed: "File non supportato",
  fileValidateTypeLabelExpectedTypes: "Tipi file accettati: {allTypes}",
  imageValidateSizeLabelFormatError: "Tipo di immagine non compatibile",
  imageValidateSizeLabelImageSizeTooSmall: "L'immagine è troppo piccola",
  imageValidateSizeLabelImageSizeTooBig: "L'immagine è troppo grande",
  imageValidateSizeLabelExpectedMinSize: "La dimensione minima è {minWidth} × {minHeight}",
  imageValidateSizeLabelExpectedMaxSize: "La dimensione massima è {maxWidth} × {maxHeight}",
  imageValidateSizeLabelImageResolutionTooLow: "La risoluzione è troppo bassa",
  imageValidateSizeLabelImageResolutionTooHigh: "La risoluzione è troppo alta",
  imageValidateSizeLabelExpectedMinResolution: "La risoluzione minima è {minResolution}",
  imageValidateSizeLabelExpectedMaxResolution: "La risoluzione massima è {maxResolution}"
};

FilePond.registerPlugin(
  // validates the size of the file
  FilePondPluginFileValidateSize,
  // validates the type of the file
  FilePondPluginFileValidateType,
  // corrects mobile image orientation
  FilePondPluginImageExifOrientation,
  // previews dropped images
  FilePondPluginImagePreview,
  // resize dropped images
  FilePondPluginImageResize,
  // validate the size of the image
  FilePondPluginImageValidateSize,
  // base64 encoding for image upload
  //FilePondPluginFileEncode
);

const filePondAttribute = 'data-filepond'
const filePondSelector = `[${filePondAttribute}]`;

let filePondItems = document.querySelectorAll(filePondSelector);

filePondItems.forEach((element, index, parent) => {
  let token = element.dataset.filepond;

  let processUrl = `/api/files/upload`;
  let loadUrl = `/api/files/load`;
  let revertUrl = `/api/files/delete`;

  let currentPond = FilePond.create(element);

  let width = element.dataset.imageResizeTargetWidth;

  let options = {
	server: {
	  process: {
		url: processUrl,
		method: 'POST',
		headers: {
		  'RequestVerificationToken': token
		},
	  },
	  load: (source, load, error, progress, abort, headers) => {
		let data = new FormData();
		data.append('fileId', source);
		data.append('width', width);

		progress(true, 0, 1024);

		fetch(`${loadUrl}`, {
		  method: 'POST',
		  headers: { 'RequestVerificationToken': token },
		  body: new URLSearchParams(data)
		})
		  .then(response => response.blob())
		  .then(data => { load(data); })
		  .catch((errors) => { error(errors); });

		return {
		  abort: () => {
			abort();
		  }
		};
	  },
	  revert: (uniqueFileId, load, error) => {
		let data = new FormData();
		data.append('fileId', uniqueFileId);

		fetch(`${revertUrl}`, {
		  method: 'POST',
		  headers: { 'RequestVerificationToken': token },
		  body: new URLSearchParams(data)
		})
		  .then(response => response.text())
		  .then(data => { load(data); })
		  .catch((errors) => { error(errors); });

		return {
		  abort: () => {
			abort();
		  }
		};
	  },
	  remove: (source, load, error) => {
		let data = new FormData();
		data.append('fileId', source);

		fetch(`${revertUrl}`, {
		  method: 'POST',
		  headers: { 'RequestVerificationToken': token },
		  body: new URLSearchParams(data)
		})
		  .then(response => response.text())
		  .then(data => { load(data); })
		  .catch((errors) => { error(errors); });

		return {
		  abort: () => {
			abort();
		  }
		};
	  }
	},
	allowReorder: false,
	onprocessfiles: function (e) {
	  if (element.dataset.isMediaModal) {
		currentPond.removeFiles();
		app.reloadMediaModal();
	  }
	},
	...defaultOptions
  }

  currentPond.setOptions(options);

  if (element.dataset.files) {
	let files = JSON.parse(element.dataset.files);
	currentPond.setOptions({ files: files });
  }
});